import { Component, OnInit, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { httpService } from '../components/body.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ViewContainerRef } from '@angular/core';
import { PDFDocument, StandardFonts } from 'pdf-lib';
//import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const FileSaver = require('file-saver');
declare var require: any

@Component({
  selector: 'app-albaranes',
  templateUrl: './albaranes.component.html',
  styleUrls: ['./albaranes.component.css']
})
export class AlbaranesComponent implements OnInit {

  //public Editor = ClassicEditor;
  muestraMenu: boolean = true;
  muestraNuevoAlbaran: boolean = false;
  muestraListaAlbaran: boolean = false;
  muestraEnviarAlbaran: boolean = false;
  muestraEstadoAlbaran: boolean = false;
  muestraInicio: boolean = true;

  @ViewChild('txtArea') txtArea: ElementRef;
  @ViewChild('txtArea') expand: ElementRef;

  txtPdf: string = "Cargar Albaran Digital (PDF)"

  cargado: boolean = false;
  fichero: any;
  descripcion: string = '';
  loading: boolean = false;
  nombreDestinatario: string = '';
  emailDestinatario: string = '';
  albaranes: any = [];
  emails: any = [];
  pdfCargado: boolean = false;
  cargadoQr: boolean = false;
  pdf: any;
  pantalla: string = '';
  albaranActual: any;
  clienteQr: any;
  descargar: boolean = false;
  // smartmail
  destinatario: string = '';
  asunto: string = '';
  texto: string = '';
  textoBox: string = '';
  muestraYes: boolean =  false;
  muestraNo: boolean = false;
  muestraBox: boolean = false;
  accion: string = '';
  muestraNuevoEmail: boolean;
  muestraListaEmail: boolean;
  idemail: any;
  ip: string;
  emailActual: any;
  lineaActual: string = 'BARRIADA DE LA PAZ';
  zoom: number = 1;
  zonaMeson: boolean = false;
  zonaPaz: boolean = false;
  zonaCentro: boolean = false;
  zonaBajo: boolean = false;
  zonaVega: boolean = false;
  verMenu: boolean = true;

  constructor( private renderer: Renderer2, public http: httpService, public toastr: ToastsManager, vcr: ViewContainerRef) {
    this.toastr.setRootViewContainerRef(vcr);
  
   }

  ngOnInit() {
   /* 
    this.http.miIp().subscribe( ip => {
      console.log(ip)
      this.ip = ip.substr(7, ip.length - 11)
    })
       this.cargarEmails();
       this.startTimer();*/
  }

  zoomMas() {
    this.zoom += 0.5;
  }

  zoomMenos() {
    this.zoom -= 0.5;
  }

  timeLeft: number = 10;
  interval;

startTimer() {
    this.interval = setInterval(() => {
      if(this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        if (this.muestraListaEmail) {
          //this.toastr.info('cargando','timer')
          this.cargarEmails(true);
          this.destinatario = 'alive@becheckin.com';
          this.asunto = 'secretaria virtual';
          this.texto = 'Secretaria virtual de correos'
          
          this.http.alive().subscribe( alive => {
            console.log('Alive: ', alive)
          })

        } 
        this.timeLeft = 10;
      }
    },1000)
  }

  pauseTimer() {
    clearInterval(this.interval);
  }


  copyTextToClipboard(text) {
    let txtArea = document.createElement("textarea");
    txtArea.id = 'txtcopy';
    txtArea.style.position = 'absolute';
    txtArea.style.top = '0';
    txtArea.style.left = '0';
    txtArea.style.opacity = '0';
    txtArea.value = text;
    document.body.appendChild(txtArea);
    txtArea.focus();
    txtArea.select();

    try {
        let successful = document.execCommand('copy');
        if (successful) {
            return true;
        }
    } catch (error) {
        console.log('No se ha podido copiar el texto: ', error);
        return false;
    } finally {
        document.body.removeChild(txtArea);
    }
    return false;
}

  refresh() {
    this.cargarEmails();
  }

  fechaToString(tipo, fecha?){
    let dias = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    let today: Date;
    if (fecha) {
      today = new Date(fecha);
    } else {
      today = new Date(Date.now());
    }

    let dd = today.getDate().toString();
    let mm = (today.getMonth() + 1).toString();
    let hh = today.getHours().toString();
    let nn = today.getMinutes().toString();
    let ss = today.getSeconds().toString();
    let yyyy: String;

    if (Number(hh) < 10) hh = '0' + hh;
    if (Number(nn) < 10) nn = '0' + nn;

    if (Number(mm) < 10) mm = '0' + mm;
    if (Number(dd) < 10) dd = '0' + dd;

    yyyy = today.getFullYear().toString();

    let result = '';

    if (tipo === 0) result = yyyy + '-' + mm + '-' + dd; // Fecha formato ingles
    if (tipo === 1) result = dd + '-' + mm + '-' + yyyy; // Fecha formato español
    if (tipo === 2) result = hh + ':' + nn; // hora formato HH:MM
    if (tipo === 3) result = yyyy + mm + dd + hh + nn + ss; // numero resumen
    if (tipo === 4) result = yyyy + '-' + mm + '-01';
    if (tipo === 5) result = yyyy + '-' + mm + '-' + dias[Number(mm) - 1];
    if (tipo === 6) result = dd + '-' + mm + '-' + yyyy + '  ' + hh + ':' + nn + ' horas.'; // Fecha formato español fecha + hora
    if (tipo === 7) result = dd + '-' + mm + '-' + yyyy + ' a las ' + hh + ':' + nn + ' horas.'; // Fecha formato español fecha + hora

    return result;
  }

  showZona(zona) {
    if (zona === 1) this.zonaPaz = true;
    if (zona === 2) this.zonaBajo = true;
    if (zona === 3) this.zonaCentro = true;
    if (zona === 4) this.zonaMeson = true;
    if (zona === 5) this.zonaVega = true;
    this.verMenu = false;

  }

  async  createPdfBurofax(email) {

    this.loading = true;

    this.muestraInicio = false;

    let fichero = ''

    if (email === 1)  { 
      fichero = 'PAZ';
      this.lineaActual = 'BARRIADA DE LA PAZ';
      this.zonaPaz = true;
      this.verMenu = false;
    }
    if (email === 2)  { 
      fichero = 'BAJO';
      this.lineaActual = 'BARRIO BAJO';
      this.zonaBajo = true;
      this.verMenu = false;
    }
    if (email === 3)  { 
      fichero = 'CENTRO';
      this.lineaActual = 'LINEA DEL CENTRO';
      this.zonaCentro = true;
      this.verMenu = false;
    }
    if (email === 4)  { 
      fichero = 'MESON';
      this.lineaActual = 'LINEA DEL MESÓN';
      this.zonaMeson = true;
      this.verMenu = false;
    }
    if (email === 5)  { 
      fichero = 'RIOS';
      this.lineaActual = 'VEGA - JUNTA DE LOS RIOS';
      this.zonaVega = true;
      this.verMenu = false;
    }
    

    const estado = '/assets/pdf/' + fichero + '.pdf';
    const pdfbytes = await fetch(estado).then(res =>
      res.arrayBuffer()
    )

    console.log(pdfbytes)

    

    const paginas = await PDFDocument.load(pdfbytes);

    let numpages = paginas.getPageCount();
    let lastpage = numpages - 1;

    const pdfDoc = await PDFDocument.create();
    const timesRomanFont = await pdfDoc.embedFont(StandardFonts.TimesRoman);
    const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)

    let pages = [];

    for (let i = 0; i < numpages; i++) {
      pages.push(i);
    }

    // console.log(pages)

    let docPages = [];
    let certPages = [];

    docPages = await pdfDoc.copyPages(paginas, pages)
    //certPages = await pdfDoc.copyPages(paginacertificado, [0]);

    for (let i = 0; i < numpages; i++) {
      pdfDoc.addPage(docPages[i])
    }

  /*

    //pdfDoc.addPage(certPages[0]);   
    let hojas = pdfDoc.getPages();
    let hojafirma = hojas[numpages - 1];
 
    hojafirma.setFont(helveticaFont);
    hojafirma.setFontSize(10);
     
    let y = hojafirma.getHeight() - 350; // coordenada Y va decreciendo
    
    hojafirma.drawText('DATOS IDENTIFICATIVOS DE LA COMUNICACIÓN', { x: 75, y: y }); y = y - 10;
    hojafirma.drawLine({ start: { x: 70, y: y }, end: {x: 550, y: y } }); y = y - 20;
    hojafirma.drawText('Estado Actual: ' + email.estado, { x: 75, y: y }); y = y - 20;
    hojafirma.drawText('Emisor: ' + email.emisor.nombre, { x: 75, y: y }); y = y - 20;
    hojafirma.drawText('Organización Emisora: ' + email.emisor.organizacion , { x: 75, y: y }); y = y - 20;
    hojafirma.drawText('Email Emisor: ' + email.emisor.email , { x: 75, y: y }); y = y - 20;
    hojafirma.drawText('Destinatario: ' + email.destinatario, { x: 75, y: y }); y = y - 20;
    hojafirma.drawText('Identificador: ' + email.idemail, { x: 75, y: y }); y = y - 20;
    hojafirma.drawText('IP Origen: ' + this.ip, { x: 75, y: y }); y = y - 40;

    hojafirma.drawText('CONTENIDO DEL CORREO', { x: 75, y: y }); y = y - 10;
    hojafirma.drawLine({ start: { x: 70, y: y }, end: {x: 550, y: y } }); y = y - 20;
    hojafirma.drawText('Asunto: ' + email.asunto, { x: 75, y: y }); y = y - 20;
    let adjunto = email.adjunto.nombre === '' ? 'Sin Adjunto' : email.adjunto.nombre
    hojafirma.drawText('Adjunto: ' + adjunto, { x: 75, y: y }); y = y - 40;
    
    hojafirma.drawText('TRAZABILIDAD DEL CORREO', { x: 75, y: y }); y = y - 10;
    hojafirma.drawLine({ start: { x: 70, y: y }, end: {x: 550, y: y } }); y = y - 20;
   
    for (let i = 0; i < email.estados.length; i++) {
      hojafirma.drawText('Estado: ' + email.estados[i].estado, { x: 75, y: y }); y = y - 20;
      hojafirma.drawText('Fecha y Hora: ' + this.fechaToString(7, email.estados[i].fecha) , { x: 75, y: y }); y = y - 30;
    }
     
    
    /*
    let my = 550;
    if ( this.albaranActual.estado !== 'Creado' && this.albaranActual.destinatario.email !== '') {
        // DATOS ENVIO
        hojafirma.drawText('ENVÍO ALBARÁN', { x: 20, y: my, size: 16, lineHeight: 18 }); my = my - 30;
        // FECHA Y HORA
        hojafirma.drawText('Fecha y Hora: ' + this.fechaToString(1, this.albaranActual.destinatario.fecha) + ' ' + this.fechaToString(2, this.albaranActual.destinatario.fecha) + ' horas', { x: 40, y: my }); my = my - 20;
        // NOMBRE DESTINATARIO
        hojafirma.drawText('Destinatario: ' + this.albaranActual.destinatario.nombre, { x: 40, y: my }); my = my - 20
        // EMAIL DESTINATARIO
        hojafirma.drawText(this.albaranActual.destinatario.email, { x: 110, y: my }); my = my - 40;
    } else {
      hojafirma.drawText('ENVíO ALBARAN', { x: 20, y: my, size: 16, lineHeight: 18  }); my = my - 30;
      hojafirma.drawText('No se ha enviado este albarán por email desde DashBoard Albarán Digital SmartBiometrik.', { x: 40, y: my }); my = my - 40;
    }


    if ( this.albaranActual.estado === 'Firmado') {
        // DATOS FIRMA / ENTREGA
        hojafirma.drawText('FIRMA / ENTREGA ALBARÁN', { x: 20, y: my, size: 16, lineHeight: 18 }); my = my - 30;
        // FECHA Y HORA
        hojafirma.drawText('Fecha y Hora: ' + this.fechaToString(1, this.albaranActual.entrega.fecha) + ' ' + this.fechaToString(2, this.albaranActual.entrega.fecha) + ' horas', { x: 40, y: my }); my = my - 20;
        // NOMBRE EMPRESA
        hojafirma.drawText('Receptor: ' + this.clienteQr.nombre, { x: 40, y: my }); my = my -20
        // ORGANIZACION
        hojafirma.drawText('Organización: ' + this.clienteQr.organizacion, { x: 40, y: my }); my = my -20
        // NOMBRE AUTORIZADO
        hojafirma.drawText('Autorizado Recogida: ' + this.albaranActual.entrega.qr.destinatario.nombre, { x: 40, y: my }); my = my - 20;
        // EMAIL AUTORIZADO
        hojafirma.drawText(this.albaranActual.entrega.qr.destinatario.email, { x: 160, y: my });
    } else {
        hojafirma.drawText('FIRMA / ENTREGA ALBARÁN', { x: 20, y: my, size: 16, lineHeight: 18 }); my = my - 30;
        hojafirma.drawText('Este Albarán Digital esta pendiente de FIRMA / ENTREGA', { x: 40, y: my }); my = my - 20;
    
    }

    

    my = my - 40;

   

    let my = 10;
    hojafirma.drawText('V_id: ' + encriptado, { x: 20, y: my, size: 10 } );
      
 */
     
    const fechafirma = this.fechaToString(1);
    const horafirma = this.fechaToString(2);


    const pdfBytes = await pdfDoc.save();
    let mypdf = new Blob([pdfBytes], { type: 'application/pdf' })
    let blobUrl = URL.createObjectURL(mypdf);
    
  
      this.pdf = blobUrl;
      this.pdfCargado = true;
      //this.muestraListaEmail = false;
      this.loading = false;
      

  }

  async savePdf() {
      let desc = this.emailActual.asunto;
      FileSaver.saveAs(this.pdf, this.emailActual.destinatario + "_" + desc + ".pdf");
  }

  async savePdfOriginal() {
   if (this.albaranActual.estado === 'Firmado') {
     this.savePdf();
   } else {
    
    let pdfBytes;
    try {
      pdfBytes = await fetch(this.albaranActual.link).then(res => res.arrayBuffer());
    } catch (error) {
      pdfBytes = await fetch('https://cors-anywhere.herokuapp.com/' + this.albaranActual.link).then(res => res.arrayBuffer())
    }

    const blob = new Blob([pdfBytes], { type: 'application/pdf' });
    const blobUrl = URL.createObjectURL(blob);

    let pdfSrc = blobUrl;
    FileSaver.saveAs(pdfSrc, this.albaranActual.descripcion + ".pdf");
  }
  
  }
  
  async cerrarEstadoAlbaran() {
   this.muestraEstadoAlbaran = false;
   this.muestraListaAlbaran = true;
  }

  link(albaran) {
    let resp = this.copyTextToClipboard('https://albarandigital.smartbiometrik.com?entrega=' + albaran._id)
    if (resp) { 
      this.http.showAlerta('Enlace copiado al Portapapeles con éxito.', 'Enlace Firma Albaran', 'success')
    } else {
      this.http.showAlerta('Ops, algo salió mal al copiar el enlace al Portapapeles. Puede copiarlo manualmente: ' + 'https://albarandigital.smartbiometrik.com?entrega=' + albaran._id, 'Enlace Firma Albaran', 'success')
    }
  }

  async estadoAlbaran(albaran) {
    this.cargadoQr = false;
    this.albaranActual = albaran;
    console.log(this.albaranActual)
    if (this.albaranActual.estado === 'Firmado') {
        this.http.getCliente(this.albaranActual.entrega.qr.emisor).subscribe( async cliente => {
          if ( cliente.status === 'ok') {
            this.clienteQr = cliente.message;
            console.log(this.clienteQr)
            await this.createPdfBurofax(true);
            this.cargadoQr = true;
            this.muestraListaAlbaran = false;
            this.muestraEstadoAlbaran = true;
          } else {
            this.http.showAlerta('Ops, algo falló al cargar el Cliente emisor del Sello Digital','Estado Albarán', 'warning', false, '')
          }
        })
    } else {
            await this.createPdfBurofax(false);
            this.cargadoQr = true;
            this.muestraListaAlbaran = false;
            this.muestraEstadoAlbaran = true;
    }
    
  }

  nuevoEmail() {
    this.muestraNuevoEmail = true;
    this.muestraListaEmail = false;
    this.destinatario = '' // 'cnica@becheckin.com';
    this.asunto = '' //'mi asunto';
    this.texto = '';
    this.fichero = null;
  }

  cerrarCargado() {
    this.pdfCargado = false;
    this.muestraInicio = true;
  }

  cancelarNuevoEmail() {
    this.muestraNuevoEmail = false;
    this.muestraListaEmail = true;
  }

  cierraTabla(index) {
    if (index === 1) this.zonaPaz = false;
    if (index === 2) this.zonaBajo = false;
    if (index === 3) this.zonaCentro= false;
    if (index === 4) this.zonaMeson = false;
    if (index === 5) this.zonaVega = false;
    this.verMenu = true;
    console.log(this.verMenu)
  }

  cerrar() {
    if (this.pantalla === 'cargar') {
      this.muestraNuevoAlbaran = true; 
      this.pdfCargado = false;
    }
    if (this.pantalla === 'listado') {
      this.muestraNuevoAlbaran = false;
      this.muestraListaAlbaran = true; 
      this.pdfCargado = false;
    }
  }

  archivo(fichero) {
      this.fichero = null;
      let nombre: String  = fichero[0].name;
      console.log(fichero)
      let ext: string  = nombre.substr(nombre.length -3, 3).toUpperCase();
      if (fichero[0].size > 51200000) {
        this.box('El fichero debe tener como máximo 50 Mb', false, true)
      } else {
        this.fichero = fichero;
      }
      
      /*
          let reader = new FileReader();
          reader.onload = (e:any) => {
            this.pdf = e.target.result;
            this.muestraNuevoAlbaran = false;
            this.pdfCargado = true;
            console.log(this.pdf)
            this.loading = false;
            this.txtPdf = this.fichero[0].name;
            this.pantalla = 'cargar';
          }
          reader.readAsArrayBuffer(this.fichero[0]); */
      
  }

  pulsado() {
    let element: Element = this.renderer.createElement('h1');
    element.innerHTML = this.txtArea.nativeElement.value +'<b> jau + <b>'
    this.renderer.appendChild(this.expand.nativeElement, element);  

  }


  cargarEmails(load?) {
    if (!load) this.loading = true;
    this.http.getEmails().subscribe( emails => {
      console.log(emails)
      this.loading = false;
      this.emails = emails.message;
      
      this.muestraMenu = false;
      this.muestraListaEmail= true;
      this.cargado = true;
      
    })
  }


  emailAlbaran(albaran) {
    if (albaran.estado !== 'Firmado') {
      this.http.albaranActual = albaran;
      this.muestraEnviarAlbaran = true; 
      this.muestraListaAlbaran = false
    } else {
      this.http.showAlerta('Este Albarán Digital ya se encuentra Firmado, no es posible enviarlo', 'Firma Albarán Digital', 'warning')
    }
    
  }

  box(texto, yes, no, accion?) {
    this.textoBox = texto;
    this.muestraYes = yes;
    this.muestraNo = no;
    this.muestraBox = true;
    this.accion = '';
    if (accion) this.accion = accion;
  }

  no() {
    this.muestraBox = false;
  }

  

  yes() {
    if (this.accion === 'borrar') {
      
    }
  }

 

 
  enviarMail() {
    this.loading = true;
    if (this.destinatario === '' || this.asunto === '') {
      this.loading = false;
      this.box('Debe especificar un Destinatario, asunto y texto valido.', false, true);
    } else {
      let certId = this.http.clienteActual._id + '-' + this.hoy();
      this.texto =  this.txtArea.nativeElement.value;
      let mcode = ''; let car = 0;
      for (let i = 0; i < this.texto.length; i++) {
        car = this.texto.charCodeAt(i);
        if  ( car === 10) {
          mcode = mcode + '<br>'
        } else {
          mcode = mcode + String.fromCharCode(car)
        }
      }

      //<img  style="visibility: hidden " src="https://apicertificado.smartbiometrik.com/updateEmailByCertificadoId/` + certId + `">
      
      let html = `
       <hr> 
      
      <p><strong><i>MailBurofax</i></strong></p>
      <p><i>Este correo ha sido enviado a través de MailBurofax para certificar el envío</i></p>
      <p><i>Asi mismo, puede certificar la entrega y lectura de este correo, en el siguiente enlace: <i><a href="https://mailburofax.smartbiometrik.com?entrega=` +  certId  +`">Certificar Entrega</a></i></p>
      <p><img hidden style="visibility:hidden" src="http://apicertificado.smartbiometrik.com/updateEmailByCertificadoId/` + certId + `"></p>
      <hr>
      <span style="display:none"></span>
      <p><strong>Enviado por: </strong>` + this.http.clienteActual.email + `
      <p><strong>Asunto: </strong>` + this.asunto + `
      <p><strong>Mensaje: </strong>
      <p>` + mcode + `</p>
      
      `

      console.log(html)

      if (this.fichero) {
        html = html +   
        ` <hr>
        <p><i>Este mensaje contiene fichero adjunto: <strong>` + this.fichero[0].name +`</strong></i></p>
        `
      }
   

      let ficherobody = this.fichero ? this.fichero[0] : null;
      let body = {
        from:  'notificaciones@mailburofax.com', //this.http.clienteActual.email,
        mailTo: this.destinatario,
        asunto: this.asunto,
        mensaje: html,
        file: ficherobody
      }

      let adjunto = {}
      if (ficherobody) {
        adjunto = { 
          nombre: ficherobody.name,
          size: ficherobody.size
        }
      } 

      this.http.sendmailfile(body).subscribe( email => {
         console.log(email)
         if (email.status === 'ok') {
          this.idemail = email.message.messageId;
          let bodymail = {
            emisor: this.http.clienteActual._id,
            destinatario:this.destinatario,
            idemail: this.idemail,
            asunto: this.asunto,
            certificacionid: certId,
            adjunto: adjunto,
            estados: {
                estado: 'Enviado'
            },
            estado: 'Enviado'
          }
          
          this.http.createEmail(bodymail).subscribe( email => {
            this.enviarConfirmacion();
          })
          
         } else {
          this.loading = false;
          this.box('Error al enviar MailBurofax. Compruebe que existe el dominio especificado.', false, true)
         }
         
      }, err => {
        this.loading = false;
        this.box('Error al enviar MailBurofax', false, true)
        
      }) 
    }
  }

  hoy() {

    const today = new Date;
    let dd = today.getDate().toString();
    let mm = (today.getMonth() + 1).toString();
    let yyyy:string;
    let hh = today.getHours().toString();
    let MM = today.getMinutes().toString();
    let ss = today.getSeconds().toString();
    let ms = today.getMilliseconds().toString();


    if(today.getDate() < 10) {

        dd = '0'+ dd;
    }

    if (today.getMonth() < 10) {
        mm = '0'+ mm;
    }

    yyyy = today.getFullYear().toString();

    let fecha = yyyy + mm  + dd + hh + MM + ss + ms;

    console.log(fecha)
  
    return  fecha;

}

  enviarConfirmacion() {
    let html = `

    <p><strong><i>MailBurofax</i></strong></p>
    <p><i>Su  MailBurofax con asunto: <strong>` + this.asunto + `</strong> ha sido enviado con éxito al destinatario: <strong>` + this.destinatario  +`<strong></i></p>
    <br>`


    let body = {
      from: 'notificaciones@mailburofax.com',
      mailTo: this.http.clienteActual.email,
      asunto: 'Certificación MailBurofax',
      mensaje: html
    }

    this.http.sendmail(body).subscribe( email => {
        this.muestraNuevoEmail = false;
        this.muestraListaEmail = true;
        this.loading = false;
        //this.box('Se ha enviado SmartMail con éxito.', false, true);
        this.cargarEmails();
        this.http.alive().subscribe( alive => {
          console.log('Alive: ', alive)
        })

        
    })
  }

  enviarAlbaran() {
    this.loading = true;
    if (this.nombreDestinatario === '' || this.emailDestinatario === '') {
      this.http.showAlerta('Debe especificar un Destinatario y un email valido.','Atención', 'warning', false, '');
    } else {
      
      let html = `
      <p><strong>ENLACE ALBARAN DIGITAL</strong></p>
      <p>Buenas, <strong>`+ this.nombreDestinatario + `</strong></p>
      <p>Se le ha enviado un ALBARAN DIGITAL desde ` + this.http.clienteActual.nombre + ` ( ` + this.http.clienteActual.organizacion +  `) </p>
      <p>Puede acceder al mismo en el siguiente enlace:</p>
      <br><a href="https://albarandigital.smartbiometrik.com?entrega=` + this.http.albaranActual._id + `">Albaran Digital</a>`; 
      
      let body = {
        mailTo: this.emailDestinatario,
        asunto: 'Albarán digital',
        mensaje: html
      }

      this.http.sendmail(body).subscribe( email => {
         this.http.showAlerta('Se ha enviado ENLACE del ALBARAN DIGITAL con éxito.', 'Albarán Digital', 'success', false, '');
         this.loading = false;
         this.http.albaranActual.destinatario.email = this.emailDestinatario.toLocaleLowerCase();
         this.http.albaranActual.destinatario.nombre = this.nombreDestinatario.toUpperCase();
         this.http.albaranActual.estado = 'Enviado';
         this.http.updateAlbaran(this.http.albaranActual).subscribe( dest => {
          //this.toastr.success('Registrado Destinatario en Albarán.');
          this.muestraEnviarAlbaran = false;
          this.muestraListaAlbaran = true;
         })
      }, err => {
        this.http.showAlerta('Error al enviar Albarán Digital', 'Albarán Digital', 'error', false, '')
        this.loading = false;
      })
    }
  }

  crearAlbaran() {
    
    if (this.fichero === null || this.descripcion === '') {
      this.http.showAlerta('Debe especificar una descripción y un fichero PDF.','Atención', 'warning', false, '');
    
    } else {
        this.loading = true;
        let bodyAlbaran = {
          destinatario: {
            nombre: this.nombreDestinatario.toUpperCase(),
            email: this.emailDestinatario.toLowerCase()
          },
          descripcion: this.descripcion.toUpperCase(),
          emisor: this.http.clienteActual._id
        }

        this.http.crearAlbaran(bodyAlbaran).subscribe( albaran => {
          
          if (albaran.status === 'ok') {
            this.http.subirfichero(this.fichero[0], this.http.clienteActual._id, albaran.message._id, this.descripcion + '.pdf').subscribe( resp => {
               if (resp.status === 'ok') {
                  console.log(resp)
                  this.http.updateLinkAlbaran(albaran.message._id, resp.url).subscribe( alb => {
                    if (resp.status === 'ok') {
                      this.fichero = null;
                      //this.cargarAlbaranes();
                      this.loading = false;
                      this.descripcion = '';
                      this.muestraNuevoAlbaran = false;
                      this.muestraListaAlbaran = true;
                      this.http.showAlerta('Albarán creado con éxito', 'Creación Albarán', 'success', false, '')
                      
                    } else {
                      this.fichero = null;
                      this.loading = false;
                      this.descripcion = '';
                      this.http.showAlerta('Opps algo no ha funcionado al crear el Albaran.', 'Atención', 'error')
                    }
                  })
               } else {
                  this.fichero = null;
                  this.loading = false;
                  this.http.showAlerta('Ha ocurrido un error al subir el fichero.','Atención', 'error');
               }
            }, err => {
              this.http.showAlerta('Ha ocurrido un error al subir el fichero.','Atención', 'error');
                  this.fichero = null;
                  this.loading = false;
                  this.descripcion = '';
            })  
         
          } else {
            this.loading = false;
            this.http.showAlerta('Opps algo no ha funcionado al crear el Albaran.', 'Atención', 'error')
          }
        }) 
        
    }
    
  }

  async open(albaran) {
    this.albaranActual = albaran;
    console.log(this.albaranActual)
    this.loading = true;
    this.muestraListaAlbaran = false; 
    let pdf = albaran.estado !== 'Firmado' ? albaran.link : albaran.entrega.link
    
    this.pdf = await fetch(pdf).then(res =>
      res.arrayBuffer()
    )

    this.muestraEstadoAlbaran = true;
    this.loading = false;
    this.pantalla = 'listado';
  }

  borrarAlbaran(albaran) {
    this.albaranActual = albaran;
    this.http.showAlerta('¿ Borrar Albarán ?', 'Borrado Albarán', 'warning', true, 'borrar')
  }

  cancelarDialog() {
    this.http.alerta.show = false;
  }

  okDialog() {
    console.log(this.http.alerta)
    if (this.http.alerta.action === 'borrar') {
      this.loading = true;
      this.albaranActual.estado = 'Borrado'
      this.http.updateAlbaran(this.albaranActual).subscribe( albaran => {
        console.log(albaran);
        this.albaranActual = '';
        //this.cargarAlbaranes();
        this.loading = false;
        this.http.showAlerta('Albarán borrado con éxito', 'Borrar Albarán', 'success',false, '')
      })
    } else {
      this.loading = false;
    }
  }

  
 
}



// WEBPACK FOOTER //
// /Users/usuario/Desktop/Angular/Urbanos/src/app/albaranes/albaranes.component.ts